export default "__VITE_ASSET__DbiV_hPG__"